window.Shopify = window.Shopify || {};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number === null) return 0;

    number = (number / 100).toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const centsPart = parts[1] ? decimal + parts[1] : '';

    return dollars + centsPart;
  }

  switch (format) {
    case '{{ amount }}':
      value = formatWithDelimiters(cents, 2);
      break;
    case '{{ amount_no_decimals }}':
      value = formatWithDelimiters(cents, 0);
      break;
    case '{{ amount_with_comma_separator }}':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case '{{ amount_no_decimals_with_comma_separator }}':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return value;
};

document.addEventListener("DOMContentLoaded", () => {
  const headerGroup = document.querySelector(
    ".shopify-section-group-header-group"
  );

  if (!headerGroup) return;

  document.documentElement.style.setProperty(
    "--header-bottom-position",
    `${parseInt(headerGroup.clientHeight)}px`
  );
});

// recently viewed products
if (window.recentlyViewedProduct) {
  try {
    const key = "ps_recently_viewed";
    const raw = localStorage.getItem(key);
    let items = raw ? JSON.parse(raw) : [];

    items = items.filter((p) => p.url !== window.recentlyViewedProduct.url);
    items.unshift(window.recentlyViewedProduct);
    items = items.slice(0, 8);

    localStorage.setItem(key, JSON.stringify(items));
  } catch {}
}

class Accordion extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector(".acc_headline");
    this.content = this.querySelector(".acc_content");
    this.accordionParent = this.closest(".accordions_parent");
    this.bindElements();
  }

  bindElements() {
    if (this.toggle) {
      this.handleAccordions();
    }
  }

  handleAccordions() {
    this.toggle.addEventListener("click", (event) => {
      console.log('this.acc', this.accordionParent);
      let otherAccordions = this.accordionParent.querySelectorAll(".acc_headline");      

      if (otherAccordions) {
        otherAccordions.forEach((acc) => {
          const accContent = acc.nextElementSibling;
          const plusIcon = acc.querySelector(".accordion-plus");
          const minusIcon = acc.querySelector(".accordion--minus");
          const downIcon = acc.querySelector(".menu-accordion-down");

          if (acc !== this.toggle && !accContent.contains(this.toggle)) {
            // collapse acc
            if (acc.classList.contains("acc_headline-opened")) {
              acc.classList.remove("acc_headline-opened");
            }
            accContent.classList.remove("acc_content-opened");
            accContent.style.maxHeight = "0px";
            accContent.style.visibility = "hidden";
            accContent.style.overflow = "hidden";
            if (plusIcon && minusIcon) {
              plusIcon.style.display = "block";
              minusIcon.style.display = "none";
            }
            if (downIcon) {
              downIcon.classList.remove("accordion_icon_rotate");
            }
          }
        });
      }

      const content = this.toggle.nextElementSibling;
      const plusIcon = this.toggle.querySelector(".accordion-plus");
      const minusIcon = this.toggle.querySelector(".accordion--minus");
      this.toggle.classList.toggle("acc_headline-opened");
      const downIcon = this.toggle.querySelector(".menu-accordion-down");

      let parent = this.toggle.parentElement;
      let parentAccordion = parent.parentElement;

      if (!content.classList.contains("acc_content-opened")) {
        // Open accordion
        content.classList.add("acc_content-opened");
        content.style.maxHeight = content.scrollHeight + "px";
        content.style.visibility = "visible";
        content.style.visibility = "initial";
        if (plusIcon && minusIcon) {
          plusIcon.style.display = "none";
          minusIcon.style.display = "block";
        }

        if (downIcon) {
          downIcon.classList.add("accordion_icon_rotate");
        }

        // if this accordion is nested inside another accordion, ensure parent can grow
        const currentAccordionEl = this.toggle.closest("accordion-component");
        const parentAccordionEl =
          currentAccordionEl && currentAccordionEl.parentElement
            ? currentAccordionEl.parentElement.closest("accordion-component")
            : null;
        if (parentAccordionEl) {
          const parentContentEl =
            parentAccordionEl.querySelector(".acc_content");
          if (parentContentEl) {
            parentContentEl.style.setProperty(
              "max-height",
              "1200px",
              "important"
            );
            parentContentEl.style.visibility = "visible";
            parentContentEl.style.overflow = "visible";
          }
        }
      } else {
        // Close accordion
        content.classList.remove("acc_content-opened");
        content.style.maxHeight = "0px";
        content.style.visibility = "hidden";
        content.style.overflow = "hidden";
        if (plusIcon && minusIcon) {
          plusIcon.style.display = "block";
          minusIcon.style.display = "none";
        }
        if (downIcon) {
          downIcon.classList.remove("accordion_icon_rotate");
        }
      }
    });
  }
}

customElements.define("accordion-component", Accordion);

// EMBBLA CAROUSEL
// global.js

// ─── HELPER METHODS ───────────────────────────────────────────────────────────

addThumbButtonClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.scrollTo(index)  // goTo → scrollTo
  )

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener('click', scrollToIndex[index], false)
  })
}
const addMainSlideClickHandlers = (emblaApi) => {
  const slides = emblaApi.slideNodes()

  slides.forEach((slide, index) => {
    slide.addEventListener('click', () => {
      const selected = emblaApi.selectedScrollSnap()
      if (index !== selected) emblaApi.scrollTo(index)
    })
  })
}
addToggleThumbButtonsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const toggleThumbBtnsState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())  // goTo → scrollTo
    const previous = emblaApiMain.previousScrollSnap()
    const selected = emblaApiMain.selectedScrollSnap()
    slidesThumbs[previous]?.classList.remove('embla-thumbs__slide--selected')
    slidesThumbs[selected]?.classList.add('embla-thumbs__slide--selected')
  }

  emblaApiMain.on('select', toggleThumbBtnsState)
  toggleThumbBtnsState()
}


const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  if (prevBtn && nextBtn) {
    const toggleState = () => {
      prevBtn.toggleAttribute("disabled", !emblaApi.canScrollPrev());
      nextBtn.toggleAttribute("disabled", !emblaApi.canScrollNext());
    };

    emblaApi
      .on("init", toggleState)
      .on("select", toggleState)
      .on("reInit", toggleState);

    return () => {
      prevBtn.removeAttribute("disabled");
      nextBtn.removeAttribute("disabled");
    };
  }
};

const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  if (prevBtn && nextBtn) {
    const scrollPrev = () => emblaApi.scrollPrev();
    const scrollNext = () => emblaApi.scrollNext();

    prevBtn.addEventListener("click", scrollPrev);
    nextBtn.addEventListener("click", scrollNext);

    const removeToggle = addTogglePrevNextBtnsActive(
      emblaApi,
      prevBtn,
      nextBtn
    );

    return () => {
      removeToggle();
      prevBtn.removeEventListener("click", scrollPrev);
      nextBtn.removeEventListener("click", scrollNext);
    };
  }
};

const addDotBtnsAndClickHandlers = (svgTypeLabel, emblaApi, dotsNode) => {
  let dotNodes = [];
  const svgType = svgTypeLabel || "tear";

  const buildDots = () => {
    const scrollSnaps = emblaApi.scrollSnapList();

    const html = scrollSnaps
      .map((_, index) => {
        const label = `Go to slide ${index + 1}`;

        if (svgType === "line") {
          return `
        <button
          class="embla__dot vertical-line-dot"
          type="button"
          aria-label="${label}"
        ></button>`;
        } else {
          return `
        <button
          class="embla__dot"
          type="button"
          aria-label="${label}"          
        >
          <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M3.50022 7.99832C2.56482 7.99832 1.68444 7.65407 1.02415 7.02771C0.363868 6.40302 0 5.57011 0 4.68514C0 3.80017 0.363868 2.96725 1.02415 2.34257L3.50022 0L5.97629 2.34257C7.34124 3.63392 7.34124 5.73636 5.97629 7.02939C5.31423 7.65575 4.43563 8 3.50022 8V7.99832Z" fill="#DEDFE3"/>
          </svg>
        </button>`;
        }
      })
      .join("");

    dotsNode.innerHTML = html;

    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    dotNodes.forEach((dot, i) =>
      dot.addEventListener("click", () => emblaApi.scrollTo(i))
    );
  };

  const syncActiveDot = () => {
    const prev = emblaApi.previousScrollSnap();
    const sel = emblaApi.selectedScrollSnap();
    dotNodes[prev]?.classList.remove("embla__dot--selected");
    dotNodes[sel]?.classList.add("embla__dot--selected");
  };

  emblaApi
    .on("init", buildDots)
    .on("reInit", buildDots)
    .on("init", syncActiveDot)
    .on("reInit", syncActiveDot)
    .on("select", syncActiveDot);

  return () => {
    dotsNode.innerHTML = "";
  };
};

// ─── SINGLE CAROUSEL INIT ────────────────────────────────────────────────────

function initEmblaCarousel(emblaNode) {
  const viewport = emblaNode.querySelector(".embla__viewport");
  const thumb = emblaNode.querySelector('.embla-thumbs__viewport');
  const prevBtn = emblaNode.querySelector(".embla__button--prev");
  const nextBtn = emblaNode.querySelector(".embla__button--next");
  const dots = emblaNode.querySelector(".embla__dots");
  const svgType = emblaNode.dataset.svg;
  var emblaApi;
  var emblaThumbs;

  if (viewport.hasAttribute("data-autoplay")) {
    const OPTIONS = { loop: true };
    emblaApi = EmblaCarousel(viewport, OPTIONS, [
      EmblaCarouselAutoplay({ playOnInit: true, delay: 8000 }),
    ]);    
  } else if (thumb) {
    emblaApi = EmblaCarousel(viewport, { align: "start" });
    emblaThumbs = EmblaCarousel(thumb, { align: 'start' });
    addThumbButtonClickHandlers(emblaApi, emblaThumbs)
    addToggleThumbButtonsActive(emblaApi, emblaThumbs)
    addMainSlideClickHandlers(emblaApi)
    emblaNode._emblaThumbs = emblaThumbs;
  } else {
    const scrollDesktop = parseInt(emblaNode.dataset.scrollDesktop, 10);
    const options = { align: "start" };
    if (scrollDesktop > 1) {
      options.slidesToScroll = scrollDesktop;
    }
    emblaApi = EmblaCarousel(viewport, options);
  }

  emblaNode._emblaApi = emblaApi;

  if (prevBtn && nextBtn) {
    const removeBtns = addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);
    emblaApi.on("destroy", removeBtns);
  }
  if (dots) {
    const removeDots = addDotBtnsAndClickHandlers(svgType, emblaApi, dots);
    emblaApi.on("destroy", removeDots);
  }

  return emblaApi;
}

// ─── GLOBAL INIT FUNCTION ───────────────────────────────────────────────────

/**
 * Initializes every `.embla` carousel on the page.
 * Call this again after you replace any carousel markup.
 */
function initAllEmblaCarousels() {
  document.querySelectorAll(".embla").forEach(initEmblaCarousel);
}

// auto-run on initial page load
document.addEventListener("DOMContentLoaded", initAllEmblaCarousels);

// expose for later calls
window.initAllEmblaCarousels = initAllEmblaCarousels;

const addAutoplayProgressListeners = (emblaApi, progressNode) => {
  const progressBarNode = progressNode.querySelector(".embla__progress__bar");

  let animationName = "";
  let timeoutId = 0;
  let rafId = 0;

  const startProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const timeUntilNext = autoplay.timeUntilNext();
    if (timeUntilNext === null) return;

    if (!animationName) {
      const style = window.getComputedStyle(progressBarNode);
      animationName = style.animationName;
    }

    progressBarNode.style.animationName = "none";
    progressBarNode.style.transform = "translate3d(0,0,0)";

    rafId = window.requestAnimationFrame(() => {
      timeoutId = window.setTimeout(() => {
        progressBarNode.style.animationName = animationName;
        progressBarNode.style.animationDuration = `${timeUntilNext}ms`;
      }, 0);
    });

    progressNode.classList.remove("embla__progress--hidden");
  };

  const stopProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    progressNode.classList.add("embla__progress--hidden");
  };

  emblaApi
    .on("autoplay:timerset", startProgress)
    .on("autoplay:timerstopped", stopProgress);

  return () => {
    emblaApi
      .off("autoplay:timerset", startProgress)
      .off("autoplay:timerstopped", stopProgress);
  };
};

const addPlayBtnListeners = (emblaApi, playBtn) => {
  const togglePlayBtnState = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const buttonText = autoplay.isPlaying() ? "Start" : "Stop";
    playBtn.innerHTML = buttonText;
  };

  const onPlayBtnClick = () => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const playOrStop = autoplay.isPlaying() ? autoplay.stop : autoplay.play;
    playOrStop();
  };

  playBtn.addEventListener("click", onPlayBtnClick);
  emblaApi
    .on("autoplay:play", togglePlayBtnState)
    .on("autoplay:stop", togglePlayBtnState)
    .on("reInit", togglePlayBtnState);

  return () => {
    playBtn.removeEventListener("click", onPlayBtnClick);
    emblaApi
      .off("autoplay:play", togglePlayBtnState)
      .off("autoplay:stop", togglePlayBtnState)
      .off("reInit", togglePlayBtnState);
  };
};

const addNavBtnListeners = (emblaApi, ...navButtons) => {
  const onNavClick = () => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const resetOrStop =
      autoplay.options.stopOnInteraction === false
        ? autoplay.reset
        : autoplay.stop;

    resetOrStop();
  };

  navButtons.forEach((navButton) =>
    navButton.addEventListener("click", onNavClick, true)
  );

  return () => {
    navButtons.forEach((navButton) =>
      navButton.removeEventListener("click", onNavClick, true)
    );
  };
};

class ReadMoreText extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = this.querySelector(".text__toggle");
    this.toggleLessBtn = this.querySelector(".text__toggle-less");
    this.textData = this.querySelector(".text__data");
  }

  connectedCallback() {
    if (!this.toggleBtn || !this.textData) return;

    let scrollPosition = 0;

    this.toggleBtn.addEventListener("click", () => {
      scrollPosition = window.scrollY;

      this.textData.classList.add("expanded");
      this.toggleBtn.classList.add("hidden");
      this.toggleLessBtn.classList.remove("hidden");
    });

    this.toggleLessBtn.addEventListener("click", () => {
      this.textData.classList.remove("expanded");
      this.toggleBtn.classList.remove("hidden");
      this.toggleLessBtn.classList.add("hidden");

      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    });
  }
}

customElements.define("readmore-text", ReadMoreText);

// Cart buble count

(() => {
  function setCartCountBubble(count) {
    const bubble = document.querySelector(".cart-count-bubble");
    if (!bubble) return count;

    let num = bubble.querySelector(".cart-count-number");

    if (!num) {
      num = document.createElement("span");
      num.className = "cart-count-number body-xs";
      num.setAttribute("aria-hidden", "true");
      bubble.appendChild(num);
    }
    num.textContent = String(count);

    if (count > 0) {
      bubble.style.display = "flex";
    } else {
      bubble.style.display = "none";
    }

    return count;
  }

  // Globalno dostupno
  window.updateCartCount = async function (input) {
    try {
      let count;

      if (typeof input === "number") {
        count = input;
      } else if (input && typeof input.item_count === "number") {
        // prosledjen cart objekat
        count = input.item_count;
      } else if (input && input instanceof Response) {
        // eventualno prosledjen fetch Response od /cart*.js
        let cart = null;
        try {
          cart = await input.clone().json();
        } catch {}
        if (cart && typeof cart.item_count === "number") {
          count = cart.item_count;
        }
      }

      if (typeof count !== "number") {
        // fallback: povuci /cart.js
        const res = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
        });
        if (!res.ok) return;
        const cart = await res.json();
        count = cart.item_count;
      }

      return setCartCountBubble(count);
    } catch (e) {
      console.warn("updateCartCount error:", e);
    }
  };
})();

function initQuizButtons() {
  const buttons = document.querySelectorAll(".quiz-opener-btn");

  buttons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      let chat = document.getElementById("shopify-chat");
      if (chat) chat.style.visibility = "hidden";

      const teaser = document.querySelector('[data-testid="animated-teaser"]');
      if (teaser) teaser.style.display = "none";
    });
  });
}

document.addEventListener("click", (e) => {
  const closeBtn = document.querySelector(".rh-widget > span");

  if (closeBtn && e.target === closeBtn) {
    let chatClose = document.getElementById("shopify-chat");
    if (chatClose) chatClose.style.visibility = "visible";

    const teaser = document.querySelector('[data-testid="animated-teaser"]');
    if (teaser) teaser.style.display = "";
  }
});

document.addEventListener("DOMContentLoaded", initQuizButtons);

// BFCM Campaign code applying

// document.addEventListener("click", (e) => {
//   const a = e.target.closest('a[href*="/discount/CYBER50"]');
//   if (!a) return;
//   localStorage.setItem("discount_code", "CYBER50");
//   localStorage.setItem('active_discount_code', "CYBER50");
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const code = localStorage.getItem("discount_code");

//   var activeDiscount = (localStorage.getItem('active_discount_code') || '');
//   if (activeDiscount === 'CYBER50') {
//     document.documentElement.classList.add('has-discount-blackf50');
//   } else {
//     document.documentElement.classList.remove('has-discount-blackf50');
//   }

//   if (code) {
//     const root = document.querySelector(".cart-notification");
//     let text = root.querySelector('.cart-notification__count ');
//     text.textContent = 'Code toegepast'

//     window.openCartNotification();
//     localStorage.removeItem("discount_code");
//   }
// });
